export const acidenteLabels = {
    atropelamento: 'Atropelamento',
    capotamento: 'Capotamento',
    choque: 'Choque',
    colisaoFrontal: 'Colisão Frontal',
    colisaoLateral: 'Colisão Lateral',
    colisaoPosterior: 'Colisão Posterior',
    colisaoTransversal: 'Colisão Transversal',
    outros: 'Outros'
}

export const condicaoDoTempoLabels = {
    bom: 'Bom',
    nublado: 'Nublado',
    chuva: 'Chuva',
    neblina: 'Neblina',
    outros: 'Outros'
}

export const luminosidadeLabels = {
    amanhecendo: 'Amanhecendo',
    plenoDia: 'Pleno Dia',
    anoitecendo: 'Anoitecendo',
    noiteComIluminacao: 'Noite Com Iluminação',
    noiteSemIluminacao: 'Noite Sem Iluminação',
    deficiente: 'Deficiente'
}

export const sinalizacaoLabels = {
    inexistente: 'Inexistente',
    agenteMobilidadeUrbana: 'Agente de Mobilidade Urbana',
    semaforo: 'Semáforo',
    faixaDePedestre: 'Faixa de Pedestre',
    linha: 'Linha',
    lombadaEletronica: 'Lombada Eletrônica',
    outros: 'Outros'
}

export const tipoDaPistaLabels = {
    asfalto: 'Asfalto',
    paralelepipedo: 'Paralelepipedo',
    concreto: 'Concreto',
    cascalho: 'Cascalho',
    outros: 'Outros'
}

export const caracteristicaDaPistaLabels = {
    acliveIngreme: 'Aclive Íngreme',
    acliveSuave: 'Aclive Suave',
    lombada: 'Lombada',
    cruzamento: 'Cruzamento',
    retorno: 'Retorno',
    entroncamento: 'Entroncamento',
    bifurcacao: 'Bifurcação',
    outros: 'Outros'
}

export const pistaLabels = {
    molhada: 'Molhada',
    inundada: 'Inundada',
    pocaDeAgua: 'Poça de Água',
    oleosa: 'Oleosa',
    enlameada: 'Enlameada',
    emObras: 'Em Obras',
    comBuraco: 'Com Buraco',
    outros: 'Outros'
}

export const getSelectedLabels = (obj, objLabels) => {
    if (!obj) return []
    return Object.keys(obj)
        .filter(key => obj[key])
        .map(key => objLabels[key])
}

export const steps = [
    {
        title: 'boat.steps.location.title',
        subtitle: 'boat.steps.location.description',
    },
    {
        title: 'boat.steps.vehicles.title',
        subtitle: 'boat.steps.vehicles.description',
    },
    {
        title: 'boat.steps.nature.title',
        subtitle: 'boat.steps.nature.description',
    },
    {
        title: 'boat.steps.versions.title',
        subtitle: 'boat.steps.versions.description',
    },
    {
        title: 'boat.steps.conditions.title',
        subtitle: 'boat.steps.conditions.description',
    },
    {
        title: 'boat.steps.observations.title',
        subtitle: 'boat.steps.observations.description',
    },
    {
        title: 'boat.steps.images.title',
        subtitle: 'boat.steps.images.description',
    }
];

export const BOAT_DATE_FORMAT = "DD/MM/YYYY HH:mm";

export const defaultBoat = {
    boatNumber: '',
    createdAt: '',
    data: {
        local: {local: '', bairro: '', cidade: '', uf: '', pontoReferencia: '', dataHoraAcidente: ''},
        acidente: {},
        condicoes: {
            condicaoDoTempo: {},
            luminosidade: {},
            sinalizacao: {},
            tipoDaPista: {},
            caracteristicaDaPista: {},
            pista: {}
        },
        veiculos: [],
        versoes: [],
        observacoes: {
            socorrista: {nome: '', rg: '', orgao: '', endereco: '', observacao: ''},
            agenteTransito: {nome: '', matricula: '', observacao: ''},
            agentesEnvolvidos: [],
        }
    }
};





export const boatTest = {
    "local": {
        "local": "Av. Alvaro Otacílio, 2991",
        "bairro": "Ponta Verde",
        "cidade": "Maceió",
        "uf": "AL",
        "pontoReferencia": "BArricas Bar",
        "dataHoraAcidente": "2025-11-19T12:15:00.000Z",
        "geolocation": {
            "latitude": -9.6468992,
            "longitude": -35.7040128
        }
    },
    "veiculos": [
        {
            "placa": "OIEWRWE",
            "marcaModelo": "FUSCA",
            "tipo": "TSFI",
            "cor": "BRANCO",
            "ano": "1973",
            "combustivel": "Gasolina",
            "uf": "PB",
            "proprietario": "SEU JOÃO",
            "numeroOcupantes": "3",
            "condutor": {
                "nome": "Haroldo Silva",
                "dataNascimento": "20/12/1999",
                "endereco": "Rua das Flores, 999",
                "cidade": "Jequié",
                "uf": "BA",
                "telefone": "(83) 82823-23333",
                "cpf": "066.233.899-29",
                "cnh": "21390",
                "validadeCnh": "14/12/2030",
                "categoriaCnh": "B"
            }
        }
    ],
    "agenteId": 1143,
    "agenteTransito": {
        "agenteId": 1143,
        "nome": "Norteware",
        "matricula": "78432"
    },
    "acidente": {
        "atropelamento": false,
        "capotamento": true,
        "choque": false,
        "colisaoFrontal": true,
        "colisaoLateral": false,
        "colisaoPosterior": false,
        "colisaoTransversal": true,
        "outros": false
    },
    "versoes": [],
    "condicoes": {
        "luminosidade": {
            "amanhecendo": true,
            "plenoDia": false,
            "anoitecendo": false,
            "noiteComIluminacao": false,
            "noiteSemIluminacao": false,
            "deficiente": false
        },
        "condicaoDoTempo": {
            "bom": true,
            "nublado": false,
            "chuva": false,
            "neblina": false,
            "outros": false
        },
        "tipoDaPista": {
            "paralelepipedo": true,
            "concreto": false,
            "cascalho": false,
            "outros": false
        },
        "caracteristicaDaPista": {
            "acliveIngreme": false,
            "acliveSuave": false,
            "lombada": false,
            "cruzamento": false,
            "retorno": false,
            "entroncamento": false,
            "bifurcacao": false,
            "outros": false
        },
        "pista": {
            "molhada": true,
            "inundada": false,
            "pocaDeAgua": false,
            "oleosa": false,
            "enlameada": false,
            "emObras": false,
            "comBuraco": false,
            "outros": false
        },
        "sinalizacao": {
            "inexistente": true,
            "agenteMobilidadeUrbana": false,
            "semaforo": false,
            "faixaDePedestre": false,
            "linha": false,
            "lombadaEletronica": false,
            "outros": false
        }
    },
    "observacoes": {
        "agenteId": 1143,
        "socorrista": {
            "nome": "",
            "documentoIdentificacao": "",
            "endereco": "",
            "telefone": "",
            "observacao": ""
        },
        "agenteTransito": {
            "agenteId": 1143,
            "nome": "Norteware",
            "matricula": "78432"
        },
        "agentesEnvolvidos": []
    },
    "imagens": [],
    "videos": [],
};